import { gql } from '@apollo/client';
import { tenant,tenantType } from '../tenant';

const QUERY_GET_USERS= gql`query getUtenti {
  clubmate_usersregister_userregister(order_by:{surname:asc}) {
    surname
    name
    fiscal_code
    id
  }
}`

const QUERY_GET_PACKAGES=gql`query getPacchetti {
  clubmate_clubmatepackage_clubmatepackage {
    id
    name
  }
}`

export {QUERY_GET_USERS,QUERY_GET_PACKAGES};